import io from 'socket.io-client';
const host = 'https://webrtc.childsay.com';
const socket = io.connect(host);
export default socket;
